module.exports = __webpack_public_path__ + "static/jointcard-icon-b26f87dca939730019a73fe698bb7e33.png";